import { Address } from "@/contexts/UserContext";
import Autocomplete from "../forms/Autocomplete/Autocomplete";
import { useState } from "react";

type AddressDropdownProps = {
  disabled?: boolean;
  invalid?: boolean;
  value: number | null,
  addressBook: Address[];
  onChange: (id: number) => void;
};

export default function AddressDropdown(props: AddressDropdownProps) {
  const { value, addressBook, disabled, invalid, onChange } = props;
  const [addressFilter, setAddressFilter] = useState('');
  const filteredAddressBook = () => {
    if (!addressFilter) {
      return [...addressBook];
    }
    return addressBook.filter(
      e => !!e.name.toLowerCase().match(
        addressFilter
          .toLowerCase()
          .replaceAll(' ', '')
          .split('')
          .map(c => c.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'))
          .join('.*')
      )
    );
  };
  return <Autocomplete
    placeholder="Choose address"
    disabled={disabled}
    invalid={invalid}
    options={filteredAddressBook()}
    optionRender={option => option.name}
    value={value == null ? null : addressBook.find(a => a.id === value)}
    onChange={e => {
      onChange(e.id);
      setAddressFilter('');
    }}
    onTextChange={setAddressFilter}
    optionToDisplayString={option => option.name}
    fullWidth
  />;
}
